import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

interface TopicInstructionSuggestionPayload {
  projectId: string;
  name: string;
  description: string;
}

interface ApprovePrefillPayload {
  fieldId: string;
  conversationId: string;
}

interface RejectPrefillPayload {
  fieldId: string;
  conversationId: string;
}

interface UpdatePrefillAnalysisPayload {
  fieldId: string;
  conversationId: string;
  analysis: string;
}

@Injectable({
  providedIn: 'root',
})
export class AIAutofillService {
  constructor(private apiService: ApiService) {}

  suggestTopicInstruction(payload: TopicInstructionSuggestionPayload): Promise<string> {
    return this.apiService.postPromise(`/ai-autofill/topic-instructions`, payload);
  }

  approvePrefill(payload: ApprovePrefillPayload): Promise<void> {
    return this.apiService.postPromise(`/ai-autofill/approve-prefill`, payload);
  }

  rejectPrefill(payload: RejectPrefillPayload): Promise<void> {
    return this.apiService.postPromise(`/ai-autofill/reject-prefill`, payload);
  }

  updatePrefillAnalysis(payload: UpdatePrefillAnalysisPayload): Promise<void> {
    return this.apiService.postPromise(`/ai-autofill/update-analysis`, payload);
  }
}
